<template>
	<div class="login" ref="index_content">
		<refundChangeTip v-if="staticPath=='/'"></refundChangeTip>
		<div class="index_content" v-if="count">
			<div class="show-pane">
				<div class="show-pane-title">
					<svg class="index_icon"><use xlink:href="#icon-shouru"></use></svg>累计总收益 
					<settlementRule></settlementRule>
				</div>
				<div class="show-pane-num">{{count.total_income}}</div>
				<div style="height: 1px;width: 100%;background:#f3f4f9;margin:10px 0 8px 0"></div>
				<div class="show-pane-bot">
                    <span> {{count.version == 1? '旧版提现余额': '可提现余额'}} {{count.surplus}}</span>
					<template v-if="operaBtnAuth.apply">
						<template v-if="staticPath === '/'">
							<el-button type="primary" size="mini" @click="widthdrawalFun" v-if="userInfo.is_cash == 1">提现</el-button>
						</template>
						<el-button type="primary" size="mini" @click="widthdrawalFun" v-else>提现</el-button>
					</template>
                </div>
			</div>
			<div class="show-pane">
				<div class="show-pane-title"><svg class="index_icon"><use xlink:href="#icon-a-shouru1"></use></svg>今日收入</div>
				<div class="show-pane-num">{{count.today_income}}</div>
				<!-- <div style="height: 1px;width: 100%;background:#f3f4f9;margin:10px 0 8px 0"></div> -->
				<!-- <div class="show-pane-bot">昨日收入 {{count.order_sum.yestoday}}</div> -->
			</div>
			<div class="show-pane">
				<div class="show-pane-title"><svg class="index_icon"><use xlink:href="#icon-a-shouru1"></use></svg>昨日收入</div>
				<div class="show-pane-num">{{count.yesterday_income}}</div>
				<!-- <div style="height: 1px;width: 100%;background:#f3f4f9;margin:10px 0 8px 0"></div> -->
				<!-- <div class="show-pane-bot">昨日收入 {{count.order_sum.yestoday}}</div> -->
			</div>
			<div class="show-pane">
				<div class="show-pane-title"><svg class="index_icon"><use xlink:href="#icon-pingjiabeifen"></use></svg>提现中</div>
				<div class="show-pane-num">{{count.withdrawn_cash_doing}}</div>
				<div style="height: 1px;width: 100%;background:#f3f4f9;margin:10px 0 8px 0"></div>
				<div class="show-pane-bot2">
                    <div>累计提现 {{count.withdrawn_cash}}</div>
                    <div @click="withdrawalRecordFun" style="color:rgb(25, 137, 250);cursor:pointer;font-size: 11px;display: inline-block;" v-if="operaBtnAuth.record">豆包账户提现记录></div>
                </div>
			</div>
		</div>
		<span style="font-size: 12px;color: red;margin-top:12px;display: inline-block" v-if='count && count.version == 1'>提示：新版提现余额请进入提现页面查看</span>
		<div style="z-index: 99999;" :style="{'height': count && count.version == 1? '12px': '20px'}">
		</div>
		<div class="mian_wrap">
			<capital-income-list></capital-income-list>
		</div>
	</div>
</template>
<script>
	import { mapState,mapActions } from 'vuex'
	import capitalIncomeList from './capitalIncomeList.vue'
	import { findBtnAuth } from '@/utils/utils.js'
	import settlementRule from './components/settlementRule.vue'
	import refundChangeTip from '@/components/tipsBox/refundChangeTip.vue'

	export default {
		name: 'Login',
		data() {
			return {
				count:null,
				day:30,
				operaBtnAuth:{
					record: false,
					apply: false
				}
			}
		},
		components: {
			'capital-income-list': capitalIncomeList,
			settlementRule,
			refundChangeTip
		},
		watch: {
			menuList: {
				deep: true,
				immediate: true,
				handler(newVal, oldVal) {
					if(newVal.length > 0) {
						this.getUserAuthBtn()
					}
				}
			}
		},
		created() {
			this.$nextTick(() => {
				this.$refs['index_content'].parentNode.classList.add('content_index')
			})
		},
		beforeRouteLeave(to,form,next) {
			this.$refs['index_content'].parentNode.classList.remove('content_index')
			next()
		},
        computed: {
            ...mapState(['breadCrumbList']),
			...mapState('login', ['userInfo']),
			...mapState("permission", ["menuList"]),
        },
		async mounted(){
			
			this.draw()
		},
		methods: {
			...mapActions('withdrawal', ['incomeStatistics']),
			// changeDay(day){
			// 	this.day = day
			// 	this.draw()
			// },
			async draw(){
				this.count = await this.incomeStatistics()
			},
            handleBreadCrumb(path, id) {
				this.$router.push({
					path: id ? path + '/' + id : path
				})
			},
            widthdrawalFun() {
                this.handleBreadCrumb(this.staticPath + 'withdrawalManage')
            },
			withdrawalRecordFun() {
				this.handleBreadCrumb(this.staticPath + 'withdrawalRecord')
			},
			getUserAuthBtn(){
				const recordName = 'btn.capitalIncome.record'
				const recordBtn = findBtnAuth(this.menuList, item => item.route_name == recordName)
				if(!!recordBtn){
					this.operaBtnAuth.record = true
				}
				
				const applyName = 'btn.capitalIncome.apply'
				const applyBtn = findBtnAuth(this.menuList, item => item.route_name == applyName)
				if(!!applyBtn){
					this.operaBtnAuth.apply = true
				}
			}
			
		}
	}
</script>
<style lang="less">
	.content_index {
		background-color: transparent!important;
		box-shadow: none!important;
		border-radius: 0!important;
		padding:0!important;
	}
</style>
<style lang="less" scoped>
	.index_content{
		height: 150px;
		display: flex;
		justify-content: space-between;
  		div{
  			div{
  				margin: auto;
  			}
  		}
	}
	.show-pane{
		// min-height: 147px;
		height: 156px;
		width: 220px;
		background: #fff;
		border-radius: 5px;
		padding: 0 0 0 20px;
		&:hover {
			box-shadow: 2px 2px 10px #ccc;
		}
		&:nth-child(1) {
			border-top: 3px solid #4E70F3;
		}
		&:nth-child(2) {
			border-top: 3px solid #FFA360;
		}
		&:nth-child(3) {
			border-top: 3px solid #67D0AF;
		}
		&:nth-child(4) {
			border-top: 3px solid #40AEFE;
		}
		.show-pane-title {
			font-size: 14px;
    		color: #888a95;
			font-weight: 600;
    		line-height: 27px;
			display: flex;
			align-items: center;
			margin-top: 17px;
		}
		.show-pane-num {
			font-size: 28px;
			font-weight: 600;
			color: #333;
			margin-top: 10px;
			margin-bottom: 10px;
		}
		.show-pane-bot{
			font-size: 14px;
    		color: #37383c;
			display: flex;
			align-items: center;
            justify-content: space-between;
            padding-right: 12px;
            box-sizing: border-box;
			.iconfont {
				color: #32b24b;
				font-weight: 600;
				transform: rotate(180deg);
				transform-origin: 50% 50%;
				&.incon_up {
					transform: rotate(0deg);
				}
			}
		}
		.show-pane-bot2{
			font-size: 14px;
    		color: #37383c;
		}
	}
	.ac{
		border: 1px solid #1989FA;
		color:#1989FA;
	}
	.bc{
		border: 1px solid #BFBFBF;
		color:#606266;
	}
	td{
		text-align: center;
		padding: 5px 10px;
	}
	.index_icon {
		width: 18px;
		height: 18px;
		vertical-align: -0.15em;
		fill: currentColor;
		overflow: hidden;
		margin-right: 6px;
	}
	.index_times{
		margin-left: 10px;
		color: red;
		font-size: 12px;
		&.index_times_sph{
			margin-left: 12px;
			display: inline-flex;
			align-items: center;
			cursor: pointer;
			.icon{
				margin: 0 0px 0 3px;
				width: 16px;
				height: 16px;
			}
		}
	}
	
	.mian_wrap {
		background-color: #fff;
		padding: 20px;
		border-radius: 5px;
		box-sizing: border-box;
		position: relative;
		// height: 550px;
		.index_radio_gr {
			position: absolute;
			right: 60px;
			top: 20px;
			z-index: 1000;
		}
	}
</style>
